import { ConcatValuesPipe } from '@shared/pipes/concat-values.pipe';
import { DateTimePipe } from '@shared/pipes/date-time.pipe';
import { DatePipe } from '@shared/pipes/date.pipe';
import { TimePipe } from '@shared/pipes/time.pipe';
import { PluckPipe } from '@shared/pipes/pluck.pipe';
import { PluralizePipe } from '@shared/pipes/pluralize.pipe';
import { ToStringIfNonePipe } from '@shared/pipes/to-string-if-none.pipe';
import { MapWithPipe } from '@shared/pipes/map-with.pipe';

export const pipes = [
  ConcatValuesPipe,
  DatePipe,
  DateTimePipe,
  TimePipe,
  PluckPipe,
  PluralizePipe,
  ToStringIfNonePipe,
  MapWithPipe,
];
